// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__amS45","collapse":"Columns_collapse__xA4Km"};